import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./CompetitionItem.css";

class CompetitionItem extends Component {
  render() {
    return (
      <div className="competition-item">
	  	<h3 className="title">{this.props.competition.name}</h3>
        <div className="actions">
          <Link to={`/admin/competition/${this.props.id}`}>View</Link>{" "}
          <Link to={`/admin/competition/${this.props.id}/edit`}>Edit</Link>
        </div>
      </div>
    );
  }
}

export default CompetitionItem;



// WEBPACK FOOTER //
// ./src/components/CompetitionItem/CompetitionItem.js